import clsx from 'clsx';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { NomineeType } from '../../types';
import { getNomineeTeam } from '../../utils/nomineeHelper';

import * as style from './style.module.scss';

const SummaryScore = ({ nominee }: { nominee: NomineeType }) => {
  const { t } = useTranslation();

  const team = useMemo(() => getNomineeTeam(nominee), [nominee]);
  const match = nominee.matchDetails;
  const winningTeam = match.winner?.match?.team;

  const summary = useMemo(() => {
    if (!winningTeam) {
      return t('draw-score-summary');
    }

    const isWinner = winningTeam.id === team.id;
    const isNomineeHomeTeam = match.homeTeam.id === team.id;
    const score = isNomineeHomeTeam
      ? `${match.score.total.home} - ${match.score.total.away}`
      : `${match.score.total.away} - ${match.score.total.home}`;
    const otherTeam = match.homeTeam.id === team.id ? match.awayTeam : match.homeTeam;
    const phrase = t(`${isWinner ? 'won' : 'lost'}-score-summary`);

    return phrase.replace(`{score}`, score).replace(`{otherTeam}`, otherTeam.internationalName);
  }, [winningTeam, team.id, match.homeTeam, match.score.total.home, match.score.total.away, match.awayTeam, t]);

  return <div className={clsx(style.ellipsis, 'pk-w--100 pk-overflow--hidden pk-d--inline-block')}>{summary}</div>;
};

export default memo(SummaryScore);
